import { Building2, Users, User } from "lucide-react";
const legendItems = [{
  icon: User,
  label: "Functionar",
  color: "bg-white-500 border-black border-[1px]"
}, {
  icon: Building2,
  label: "Institutie",
  color: "bg-purple-500"
}, {
  icon: Users,
  label: "Departament",
  color: "bg-orange-500"
}];
export function Legend() {
  return <div className="rounded-lg border bg-card p-4 shadow-sm" data-sentry-component="Legend" data-sentry-source-file="Legend.tsx">
      <div className="flex items-center justify-center gap-6">
        {legendItems.map(item => <div key={item.label} className="flex items-center gap-2">
            <div className={`border-1 h-3 w-3 rounded-full ${item.color}`} />
            <item.icon className="h-4 w-4" />
            <span className="text-sm">{item.label}</span>
          </div>)}
      </div>
    </div>;
}